export default __webpack_public_path__ + "static/video-poster-5d52795e8fdd8db4391411308bc0cce8.webp";